import { isEmpty } from "lodash";
import { INITIAL_STATE } from "../constants/AppConstants";
import { SET_CURRENT_USER } from "../constants/ActionTypes";

export default (state = INITIAL_STATE, action = {}) => {
  switch (action.type) {
    case SET_CURRENT_USER:
      return {
        ...state,
        auth: {
          get isAuthenticated() {
            return !isEmpty(action.user) && localStorage.getItem("flask_url") && localStorage.getItem("verified");
          },
          user: action.user
        }
      };
    default:
      return state;
  }
};
